package music.jammers.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.UserAcceptance

class GetUserAcceptanceUseCase(
    private val eventRepository: EventRepository,
) {

    suspend operator fun invoke(eventId: Long): UserAcceptance =
        eventRepository.getAcceptance(eventId)
}